<template>
<div class="header-box">
<dv-border-box-8>
<div class="header">
  <div class="title">{{year}}年AI需求预估</div>
  <div class="item-group">
    <div class="item" v-for="(item, index) in headerData" :key="index">
      <div>
        <div>全年预估</div>
        <div>{{ item.name }}</div>
      </div>
      <div>
        <dv-digital-flop :config="{
              number: [item.value],
              toFixed: valuePlaces(index),
              textAlign: 'right',
              style: lineStyle
            }" 
            style="height: 68px" />
         {{ item.company }}
      </div>
    </div>
  </div>
</div>
</dv-border-box-8>
</div>
</template>

<script>
import { getAiData } from '../../../api/colunm4'
import { header } from '../js/data'
export default {

  data() {
    return {
      headerData: header,
      timer: null,
      lineStyle: {
        fill: '#34DEE5',
        fontSize: 34,
        fontWeight: 'bold'
      }
    }
  },

  computed: {
    year () {
      const date = new Date()
      return date.getFullYear()
    }
  },

  created () {
    this.getPageData()
  },

  methods: {
    getPageData () {
      getAiData().then(res => {
        res.forEach((element, i) => {
          this.headerData[i].value = Number(element.value)
        })
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getPageData, 1000 * 10)
      })
    },

    valuePlaces (index) {
      switch (index) {
        case 0:
          return 2
        case 1:
          return 1
        case 2:
          return 2
        case 3:
          return 0
        case 4: 
          return 2
        case 5:
          return 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header-box {
  width: 648px;
  height: 272px;
}
.header {
  display: flex;
  flex-direction: column;
  width: 648px;
  height: 272px;
  padding: 6px 22px 16px 18px;
  background: linear-gradient(-21deg, rgba(14, 49, 115, 0.5), rgba(7, 20, 73, 0.5));
  .title {
    color: #34DEE5;
    font-size: 21px;
    font-weight: bold;
  }
  .item-group {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 297px;
    height: 68px;
    padding: 0 17px 0 10px;
    border-radius: 12px;
    color: #FFFFFF;
    white-space: nowrap;
    font-weight: bold;
    background: linear-gradient(0deg, #07205B 0%, #060D34 100%);
    & > div:nth-child(1) {
      font-size: 17px;
      white-space: nowrap;
    }
    & > div:nth-child(2) {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 21px;
    }
  }
}
</style>